import InquiriesAPI, {
  createInquiry as createInquiryRaw,
  deleteInquiry as deleteInquiryRaw,
  getInquiries as getInquiriesRaw,
  updateInquiry as updateInquiryRaw,
} from "@/api/inquiries";
import type { Inquiry } from "./inquiries.types";

type GetInquiriesQuery = {
  inquiry_id?: number;
  search?: string;
  page?: number;
  pageSize?: number;
  [key: string]: unknown;
};

export const getInquiries = (
  options: GetInquiriesQuery = {}
): Promise<Inquiry[]> => getInquiriesRaw(options);

export type CreateInquiryPayload = Omit<
  Partial<Inquiry>,
  "client_id" | "custom_attributes" | "inquiry_email" | "inquiry_org"
> & {
  client_id?: number | null;
  inquiry_email?: string | null;
  inquiry_org?: string | null;
  inquiry_name?: string;
  custom_attributes?: { field_id: number; value: unknown }[];
};

export const createInquiry = (
  payload: CreateInquiryPayload
): Promise<Inquiry> => createInquiryRaw(payload);

export type UpdateInquiryPayload = Omit<
  Partial<Inquiry>,
  "custom_attributes"
> & {
  custom_attributes?: {
    attribute_id?: number | null;
    field_id: number;
    field_name?: string;
    item_id?: number;
    value: unknown;
    editor_type?: string;
    description?: string;
    options?: unknown;
  }[];
};

export const updateInquiry = (
  inquiryId: number,
  payload: UpdateInquiryPayload
): Promise<Inquiry> => updateInquiryRaw(inquiryId, payload);

export const deleteInquiry = (inquiryId: number): Promise<unknown> =>
  deleteInquiryRaw(inquiryId);

export { InquiriesAPI };
